
define('app/dashboard/leagues/instances/views/lgPositionsView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productTypeModel',
	'known/models/leaguePositionModel',
	'known/collections/leaguePositionCollection',
	'app/dashboard/leagues/instances/views/lgPositionAddView',
	'app/dashboard/leagues/instances/views/lgPositionSettingsView',
	'app/dashboard/leagues/instances/views/lgPositionDelView',
	
	//Templates
	'text!app/dashboard/leagues/instances/templates/lgPositionTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		ProductTypeModel,
		LeaguePositionModel,
		LeaguePositionCollection,
		LeaguePositionAddView,
		LeaguePositionSettingsView,
		LeaguePositionDelView,
		lgPositionHtml){
	
	var LeaguePositionView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel;
			this.lgInstance = options.lgInstance;
			this.position = options.position;
			this.prodType = options.prodType;
			this.prodConfig = options.prodConfig;
			
			this.positionTemplate = _.template(lgPositionHtml.trim());
			
			this.buildEl();
			
			this.settingsView = new LeaguePositionSettingsView({
				el: $(this.el),
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				position: this.position,
				prodType: this.prodType,
				prodConfig: this.prodConfig});
			
			this.deleteView = new LeaguePositionDelView({
				el: $(this.el),
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				position: this.position,
				prodType: this.prodType,
				prodConfig: this.prodConfig});
			
			this.listenTo(this.position, 'change', this.updateVisuals);
			this.listenTo(this.position, 'reset', this.updateVisuals);
		},
		
		render: function () {
			this.settingsView.render();
			this.deleteView.render();
			
			return this;
		},
		
		buildEl: function() {
			var positions = this.position.get('positions');
			var positionsStr = "";
			for (var i = 0; i < positions.length; i++) {
				if(i>0){
					positionsStr += ",";
				}
				
				positionsStr += positions[i];
			}
			
			var color = this.position.get('color');
			if(color.charAt(0) != "#"){
				color = "#" + color;
			}
			
			this.setElement($(this.positionTemplate({
				posName: this.position.get('name'),
				starters: this.position.get('starters'),
				min: this.position.get('min'),
				max: this.position.get('max'),
				color: color,
				positions: positionsStr})));
			
			this.updateVisuals();
		},
		
		updateVisuals: function() {
			var positions = this.position.get('positions');
			var positionsStr = "";
			for (var i = 0; i < positions.length; i++) {
				if(i>0){
					positionsStr += ",";
				}
				
				positionsStr += positions[i];
			}
			
			var color = this.position.get('color');
			if(color.charAt(0) != "#"){
				color = "#" + color;
			}
			
			$(this.el).find('.posNameText').html(this.position.get('name'));
			$(this.el).find('.posStartersText').html(this.position.get('starters'));
			$(this.el).find('.posMinMaxText').html(this.position.get('min') + '/' + this.position.get('max'));
			$(this.el).find('.posTypesText').html(positionsStr);
			$(this.el).find('.posColorPreview').css({ "background-color": color});
			
			if(positions.length > 1){
				$(this.el).find('.colorContainer').hide();
				$(this.el).find('.positionComposition').show();
			} else {
				$(this.el).find('.positionComposition').hide();
				$(this.el).find('.colorContainer').show();				
			}
		},
	    
	    destroyView: function() {
	    	this.settingsView.destroyView();
	    	this.deleteView.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var LeaguePositionsView = Backbone.View.extend({
		el: $("#positionGrp"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodType = options.prodType;
			this.prodConfig = options.prodConfig;
			
			this.refreshingPositions = false;
			
			this.addPositionView = new LeaguePositionAddView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			
			//this.listenTo(this.lgInstance, 'change', this.updateVisuals);
			this.listenTo(this.lgInstance, 'add:leaguePositions', this.addPosition);
			this.listenTo(this.lgInstance, 'remove:leaguePositions', this.removePosition);
			
			this.positionContainer = $(this.el).find('#positionContainer');
			this.positionViews = [];
		},
		
		render: function () {
			this.renderPositions();
			
			this.addPositionView.render();
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			if(this.lgInstance.isCommissioner(this.userModel.get('userName'))
					&& this.prodConfig.CUSTSCORING == 'false'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				$(this.el).find('#positionUpgradeNote').show();
			} else {
				$(this.el).find('#positionUpgradeNote').hide();
			}
		},
		
		renderPositions: function() {
			this.removeAllPositions();
			this.positionContainer.empty();
			this.addAllPositions();
		},
		
		addPosition: function(position) {
			var view = new LeaguePositionView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				position: position,
				prodType: this.prodType,
				prodConfig: this.prodConfig});
			this.positionContainer.append(view.render().el);
			this.positionViews[position.cid] = view;
		},
		
		removePosition: function(position) {
			this.positionViews[position.cid].destroyView();
			delete this.positionViews[position.cid];
		},
		
		addAllPositions: function() {
			this.lgInstance.get("leaguePositions").each(function(position){
				this.addPosition(position);
			}, this);
		},
		
		removeAllPositions: function() {
			_.each(this.positionViews, function(view, key){
				this.positionViews[key].destroyView();
				delete this.positionViews[key];
			}, this);
		},
		
	});
	
	return LeaguePositionsView;  
});